module.exports = __webpack_public_path__ + "img/7S.176a4b9e.png";